import {  Grid } from "@material-ui/core"
import { useState, useEffect } from "react";
import { AppDispatch } from "../../redux/store";
import {useSelector,useDispatch } from "react-redux";
import { Bar } from "react-chartjs-2";
import { Text } from "sunrise-ui";
import FilterComponent from "../../components/helperComponents/FilterComponent";
import { CHART_COLORS, customTooltip } from "../../constants/reactChartConstants";
import {  getOverallExpensesBillReport, getOverallExpensesInventoryBillReport, getOverallExpensesMachineRentalBillReport, getOverallExpensesMachineryRepairBillReport, getOverallExpensesMiscellaneousBillReport, getOverallExpensesSubContractorBillReport } from "../../redux/reducers/billReducer";

const BillReportBar = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [value, setValue] = useState({ from: "", to: "" });

    const overallExpensesBillReport = useSelector((state: any) => state.BILLS.overallExpensesBillReport);
    const overallInventoryBillReport = useSelector((state: any) => state.BILLS.overallExpensesInventoryBillReport);
    const overallSubContractorBillReport = useSelector((state: any) => state.BILLS.overallExpensesSubContractorBillReport);
    const overallMachineRentalBillReport = useSelector((state: any) => state.BILLS.overallExpensesMachineRentalBillReport);
    const overallMachineryRepairBillReport = useSelector((state: any) => state.BILLS.overallExpensesMachineryRepairBillReport);
    const overallMiscellaneousBillReport = useSelector((state: any) => state.BILLS.overallExpensesMiscellaneousBillReport);

    const handleFilterDate = () => {
        if(value.to && value.from){
            dispatch(
                getOverallExpensesBillReport({
                    endPoint: `manage-bill/expense-report?to=${value.to}&from=${value.from}`,
                })
            );
            dispatch(
                getOverallExpensesInventoryBillReport({
                    endPoint: `manage-bill/expense-report-by-type?billType=inventory&to=${value.to}&from=${value.from}`,
                })
            );
            dispatch(
                getOverallExpensesSubContractorBillReport({
                    endPoint: `manage-bill/expense-report-by-type?billType=sub-contractor&to=${value.to}&from=${value.from}`,
                })
            );
            dispatch(
                getOverallExpensesMachineRentalBillReport({
                    endPoint: `manage-bill/expense-report-by-type?billType=machine-rental&to=${value.to}&from=${value.from}`,
                })
            );
            dispatch(
                getOverallExpensesMachineryRepairBillReport({
                    endPoint: `manage-bill/expense-report-by-type?billType=machinery-repair&to=${value.to}&from=${value.from}`,
                })
            );
            dispatch(
                getOverallExpensesMiscellaneousBillReport({
                    endPoint: `manage-bill/expense-report-by-type?billType=miscellaneous&to=${value.to}&from=${value.from}`,
                })
            );
        }
    }

    const resetToAll = () => {
        setValue({ from: "", to: "" });
        dispatch(
            getOverallExpensesBillReport({
                endPoint: `manage-bill/expense-report`,
            })
        );
        dispatch(
            getOverallExpensesInventoryBillReport({
                endPoint: `manage-bill/expense-report-by-type?billType=inventory`,
            })
        );
        dispatch(
            getOverallExpensesSubContractorBillReport({
                endPoint: `manage-bill/expense-report-by-type?billType=sub-contractor`,
            })
        );
        dispatch(
            getOverallExpensesMachineRentalBillReport({
                endPoint: `manage-bill/expense-report-by-type?billType=machine-rental`,
            })
        );
        dispatch(
            getOverallExpensesMachineryRepairBillReport({
                endPoint: `manage-bill/expense-report-by-type?billType=machinery-repair`,
            })
        );
        dispatch(
            getOverallExpensesMiscellaneousBillReport({
                endPoint: `manage-bill/expense-report-by-type?billType=miscellaneous`,
            })
        );

    }

    useEffect(()=>{
        dispatch(
            getOverallExpensesBillReport({
                endPoint: `manage-bill/expense-report`,
            })
        );
        dispatch(
            getOverallExpensesInventoryBillReport({
                endPoint: `manage-bill/expense-report-by-type?billType=inventory`,
            })
        );
        dispatch(
            getOverallExpensesSubContractorBillReport({
                endPoint: `manage-bill/expense-report-by-type?billType=sub-contractor`,
            })
        );
        dispatch(
            getOverallExpensesMachineRentalBillReport({
                endPoint: `manage-bill/expense-report-by-type?billType=machine-rental`,
            })
        );
        dispatch(
            getOverallExpensesMachineryRepairBillReport({
                endPoint: `manage-bill/expense-report-by-type?billType=machinery-repair`,
            })
        );
        dispatch(
            getOverallExpensesMiscellaneousBillReport({
                endPoint: `manage-bill/expense-report-by-type?billType=miscellaneous`,
            })
        );
    },[dispatch])
    //-------bar chart data------------
const barChartData = {
    labels: ["Overall", "Inventory", "Labor Contractor", "Machinery Rental", "Machinery Repair", "Miscellaneous"],
    datasets: [
        {
            label: "Approved",
            data: [overallExpensesBillReport?.approveCount , 
                overallInventoryBillReport?.approveCount, 
                overallSubContractorBillReport?.approveCount ,
                overallMachineRentalBillReport?.approveCount , 
                overallMachineryRepairBillReport?.approveCount , 
                overallMiscellaneousBillReport?.approveCount ],
            backgroundColor: [CHART_COLORS.BLUE, CHART_COLORS.BLUE, CHART_COLORS.BLUE, CHART_COLORS.BLUE],
            hoverBackgroundColor: [CHART_COLORS.SELECTED_BLUE, CHART_COLORS.SELECTED_BLUE, CHART_COLORS.SELECTED_BLUE, CHART_COLORS.SELECTED_BLUE]
        },
        {
            label: "Pending",
            data:  [overallExpensesBillReport?.pendingCount, 
                overallInventoryBillReport?.pendingCount , 
                overallSubContractorBillReport?.pendingCount ,
                overallMachineRentalBillReport?.pendingCount , 
                overallMachineryRepairBillReport?.pendingCount , 
                overallMiscellaneousBillReport?.pendingCount ],
            backgroundColor: [CHART_COLORS.YELLOW, CHART_COLORS.YELLOW, CHART_COLORS.YELLOW, CHART_COLORS.YELLOW],
            hoverBackgroundColor: [CHART_COLORS.SELECTED_YELLOW, CHART_COLORS.SELECTED_YELLOW, CHART_COLORS.SELECTED_YELLOW, CHART_COLORS.SELECTED_YELLOW]
        },
        {
            label: "Rejected",
            data:  [overallExpensesBillReport?.rejectCount , 
                overallInventoryBillReport?.rejectCount , 
                overallSubContractorBillReport?.rejectCount ,
                overallMachineRentalBillReport?.rejectCount , 
                overallMachineryRepairBillReport?.rejectCount , 
                overallMiscellaneousBillReport?.rejectCount ],
            backgroundColor: [CHART_COLORS.RED, CHART_COLORS.RED, CHART_COLORS.RED, CHART_COLORS.RED],
            hoverBackgroundColor: [CHART_COLORS.SELECTED_RED, CHART_COLORS.SELECTED_RED, CHART_COLORS.SELECTED_RED, CHART_COLORS.SELECTED_RED]

        },
    ],
};

const billReportBarOptions: any = {
    plugins: {
        tooltip: customTooltip
    },
    maintainAspectRatio: false,
    scales: {
        y: { title: { display: true, text: 'Number of Bills', font: { weight: 'bold' } } },
        x: { title: { display: true, text: 'Bill Type', font: { weight: 'bold' } } },
    }
}


    return (
       
            <Grid container xs={12} className="d-flex bg--white box--shadow p1 mt1 mr-1">
                <Grid item xs={12}>
                    <Grid className="d-flex p1">
                        <Text
                            type="normal"
                            fonts="normal"
                            fontSize={18}
                            className="mb0 mt0"
                        >
                            <span className="fw500">Bill Report</span>
                        </Text>
                        <Grid item className={"ml-1 mt0"}
                            direction="row"
                            alignItems="center">
                            <div className="filter_box_ml">
                                <FilterComponent
                                    handleFilterDate={handleFilterDate}
                                    setValue={setValue}
                                    value={value}
                                    resetAll={resetToAll}
                                />
                            </div>
                        </Grid>
                        {/* <Grid item className="ml-1 mt0">
                            <Button
                                type="button"
                                size="medium"
                                isRounded={true}
                                category="primary"
                                onClick={() => {
                                }}
                                className="submit_button mb1 mr-1 pl pr f14"
                            >
                                <SVG type={"searchIcon"} />
                                Search
                            </Button>
                        </Grid> */}
                    </Grid>
                </Grid>

                <Grid item xs={11} style={{ height: 300 }}>
                    <Bar data={barChartData} options={billReportBarOptions} />
                </Grid>
            </Grid>
     
    )
}

export default BillReportBar;